import { render, staticRenderFns } from "./SkeletonGroups.vue?vue&type=template&id=776903bf"
import script from "./SkeletonGroups.vue?vue&type=script&lang=js"
export * from "./SkeletonGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports